module.exports = __webpack_public_path__ + "static/media/IAP_Backing@3x.899c44d0.png";